import { render, staticRenderFns } from "./UnAuthorize.vue?vue&type=template&id=e4defdfa&scoped=true"
import script from "./UnAuthorize.vue?vue&type=script&lang=js"
export * from "./UnAuthorize.vue?vue&type=script&lang=js"
import style0 from "./UnAuthorize.vue?vue&type=style&index=0&id=e4defdfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4defdfa",
  null
  
)

export default component.exports